@if (residencePermits === null || residencePermits?.length === 0) {
  <div class="info-card-empty">
    <i class="fa fa-inbox info-card-empty__icon"></i>
    <span>{{ 'GENERAL.no_data' | translate }}</span>
  </div>
}

@if (residencePermits?.length > 0) {
  <div class="permit-cards">
    @for (residencePermit of residencePermits; track residencePermit) {
      <div class="permit-card" [class.permit-card--expired]="isExpired(residencePermit.endDate)">
        <div class="permit-card__status">
          @if (isExpired(residencePermit.endDate)) {
            <span class="permit-status permit-status--expired">
              <i class="fa fa-exclamation-circle"></i>
              {{ 'PERSONAL_DATA.PERMITS.expired' | translate }}
            </span>
          } @else {
            <span class="permit-status permit-status--valid">
              <i class="fa fa-check-circle"></i>
              {{ 'PERSONAL_DATA.PERMITS.valid' | translate }}
            </span>
          }
        </div>
        <div class="permit-card__content">
          <div class="permit-card__row">
            @if (getTranslatedData(residencePermit?.nationality)) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.nationality' | translate }} : </span>
                <span class="permit-card__value">{{ getTranslatedData(residencePermit?.nationality) }}</span>
              </div>
            }
            @if (residencePermit?.residencePermitId) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.number' | translate }} : </span>
                <span class="permit-card__value permit-card__value--id">{{ residencePermit?.residencePermitId }}</span>
              </div>
            }
          </div>
          <div class="permit-card__row">
            @if (residencePermit?.startDate) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.startdate' | translate }} : </span>
                <span class="permit-card__value">{{ residencePermit?.startDate | date:'dd/MM/yyyy' }}</span>
              </div>
            }
            @if (residencePermit?.endDate) {
              <div class="permit-card__item">
                <span class="permit-card__label">{{ 'PERSONAL_DATA.PERMITS.enddate' | translate }} : </span>
                <span class="permit-card__value" [class.permit-card__value--warning]="isExpired(residencePermit.endDate)">
                  {{ (residencePermit?.endDate | date:'dd/MM/yyyy' | unlimitedDate) | translate }}
                </span>
              </div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
